import { render, staticRenderFns } from "./IssuesChrome.vue?vue&type=template&id=03f8b9c7&scoped=true&"
import script from "./IssuesChrome.vue?vue&type=script&lang=js&"
export * from "./IssuesChrome.vue?vue&type=script&lang=js&"
import style0 from "./IssuesChrome.vue?vue&type=style&index=0&id=03f8b9c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8b9c7",
  null
  
)

export default component.exports